module.exports = __webpack_public_path__ + "img/hero-mobile@2x.1cd9ea7a.webp";